import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Grid,
  Fab,
  Icon,
  TextField,
  FormHelperText,
  MenuItem,
  FormControl,
  Select,
  Dialog,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  getBrands,
  addAffiliatesBannerSlideApi,
  editAffiliatesBannerSlideApi,
  addFullfilmentBannerSlideApi,
  editFullfilmentBannerSlideApi
} from 'api';
import { uploadFileTypeUnsupported } from 'redux/actions/general';


const useStyles = makeStyles(() => ({
  dropzone_error: {
    borderColor: '#FF3D57'
  }
}));

const slideTypes = [
  'Direct Fulfillment',
  'Affiliate'
];

const urlTypes = ['brand', 'externalLink', 'cmsIdentifier'];

const BannerSlideModal = ({slideData, setOpen}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [dargClass, setDragClass] = useState('');
  const [slideFor, setSlideFor] = useState(slideData.slideType || 'Direct Fulfillment');
  const [bannerData, setBannerData] = useState(slideData);
  const {brandsData} = useSelector((state) => state.brands);

  const handleDragStart = () => setDragClass('drag-shadow');

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragClass('drag-shadow');
  };

  useEffect(() => {
    if (brandsData) {
      getBrands({dispatch});
    }
  }, []);

  const handleSaveSlide = () => {
    const formData = new FormData();

    for (const key in bannerData) {
      const element = bannerData[key];
      formData.append(key, element);
    }

    if (slideFor === 'Direct Fulfillment') {
      if (bannerData._id) {
        editFullfilmentBannerSlideApi({dispatch, formData, id: bannerData._id});
      } else {
        addFullfilmentBannerSlideApi({dispatch, formData});
      }
    } else if (bannerData._id) {
      editAffiliatesBannerSlideApi({dispatch, formData, id: bannerData._id});
    } else {
      addAffiliatesBannerSlideApi({dispatch, formData});
    }

    setOpen(false);
  };

  const handleUploadSlideOnDrag = (event) => {
    event.preventDefault();

    const {files} = event.dataTransfer;
    const fileName = files[0].name;
    const fileTypeDotIndexPosition = fileName.lastIndexOf('.') + 1;
    const slicedFileTypeFromFilePath = fileName.slice(fileTypeDotIndexPosition);
    const acceptableFormats = 'png|jpeg|jpg';
    const hasImageFile = new RegExp(`(image\\/(${acceptableFormats}))`, 'gi');

    if (!hasImageFile.test(files[0].type) && !hasImageFile.test(slicedFileTypeFromFilePath)) {
      dispatch(uploadFileTypeUnsupported());
      setDragClass('');
      return setBannerData((d) => ({...d, image: ''}));
    }

    setDragClass('');
    return setBannerData((d) => ({...d, image: files[0]}));
  };

  const handleUpLoadSlide = (event) => {
    const {files} = event.target;
    const fileName = event.target.value;
    const fileTypeDotIndexPosition = fileName.lastIndexOf('.') + 1;
    const slicedFileTypeFromFilePath = fileName.slice(fileTypeDotIndexPosition);
    const acceptableFormats = 'png|jpeg|jpg';
    const hasImageFile = new RegExp(`(image\\/(${acceptableFormats}))`, 'gi');

    if (!hasImageFile.test(files[0].type) && !hasImageFile.test(slicedFileTypeFromFilePath)) {
      dispatch(uploadFileTypeUnsupported());
      return setBannerData((d) => ({...d, image: ''}));
    }

    return setBannerData((d) => ({...d, image: files[0]}));
  };

  return (
    <Dialog
      open={!!slideData}
      onClose={() => setOpen(false)}
      aria-labelledby="edit-slide"
      fullWidth
      maxWidth={'md'}
    >
      <DialogTitle
        id="edit-slide"
        className={classes.heading}
      >
        {bannerData._id ? 'Edite Slide' : 'Create Slide'}
      </DialogTitle>
      <DialogContent
        className="px-8 pb-8"
      >
        <Grid container>
          <Grid item xs={12}>
            {bannerData.image ?
              <img src={typeof bannerData.image === 'object' ? URL.createObjectURL(bannerData.image) : bannerData.image} alt="slide" className="max-w-full" />
              :
              <>
                <div
                  className={`h-300 w-full p-4 flex-column justify-center items-center dropzone ${dargClass}`}
                  onDragEnter={handleDragStart}
                  onDragOver={handleDragOver}
                  onDrop={handleUploadSlideOnDrag}
                >
                  <div>
                    <Icon className="pr-8 text-48" fontSize="large" color="primary">cloud_upload</Icon>
                  </div>

                  <span className="font-bold text-16 text-brand">
                    {'Drag and drop your file here'}
                    <span className="text-error">*</span>
                  </span>
                  <span className="text-13 text-muted">Files supported:  JPG, JPEG, PNG</span>
                  <p className="text-13 text-brand my-2">or</p>
                  <label htmlFor="upload-slide-image">
                    <Fab
                      component="span"
                      variant="extended"
                      className="border-radius-30 capitalize bg-white text-13 h-30px text-primary font-bold border-1-primary box-shadow-none"
                    >
                      Browse file
                    </Fab>
                  </label>
                  <input
                    className="hidden"
                    onChange={handleUpLoadSlide}
                    id="upload-slide-image"
                    type="file"
                    accept="image/png, image/jpeg"
                  />
                </div>
                {Boolean(bannerData.image) &&
                  <FormHelperText
                    error
                    className="pl-4"
                  >
                    Field is required
                  </FormHelperText>
                }
              </>
            }
            {bannerData.image &&
            <Grid item xs={12}>
              <label htmlFor="upload-image">
                <Fab
                  component="span"
                  variant="extended"
                  className="border-radius-30 capitalize bg-white text-13 h-30px text-primary font-bold border-1-primary box-shadow-none w-full"
                >
                  <Icon className="pr-8" color="primary">cloud_upload</Icon>
                  <span>Upload New Image</span>
                </Fab>
              </label>
              <input
                className="hidden"
                onChange={handleUpLoadSlide}
                id="upload-image"
                type="file"
                accept="image/png, image/jpeg"
              />
            </Grid>}
          </Grid>
        </Grid>
        <Grid container className="p-4 items-center">
          <Grid item xs={3}>Slide For: <span className="text-error">*</span></Grid>
          <Grid item xs={9}>
            <FormControl className={classes.formControl}>
              <Select
                size="small"
                fullWidth
                labelId="slideForLabel"
                id="slideFor"
                value={slideFor}
                onChange={(e) => setSlideFor(e.target.value)}
              >
                {slideTypes.map((type) => <MenuItem fullWidth key={type} value={type}>{type}</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container className="p-4 items-center">
          <Grid item xs={3}>Url Type: <span className="text-error">*</span></Grid>
          <Grid item xs={9}>
            <FormControl className={classes.formControl}>
              <Select
                size="small"
                fullWidth
                labelId="urlTypeLabel"
                id="urlType"
                value={bannerData.urlType}
                onChange={(e) => {
                  const {value} = e.target;
                  setBannerData((d) => ({...d, urlType: value}));
                }}
              >
                {urlTypes.map((type) => <MenuItem fullWidth key={type} value={type}>{type}</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {bannerData.urlType === 'brand' &&
        <Grid container className="p-4 flex items-center">
          <Grid item xs={12} md={3}>Related Brand: <span className="text-error">*</span></Grid>
          <Grid item xs={12} md={9}>
            {!!brandsData.length &&
              <Autocomplete
                size="small"
                disableClearable
                name="brandName"
                value={brandsData.find((brand) => brand.value === bannerData.brandName) || ''}
                options={brandsData}
                getOptionLabel={(option) => option.value || ''}
                getOptionSelected={(option) => option.option_id == bannerData.brandId}
                onChange={(_, brand) => {
                  setBannerData((d) => ({...d, brandName: brand.value, brandId: brand.option_id }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    label="Brand"
                  />
                )}
              />
            }
          </Grid>
        </Grid>}
        {bannerData.urlType === 'externalLink' &&
        <Grid container className="p-4 flex items-center">
          <Grid item xs={12} md={3}>External link: <span className="text-error">*</span></Grid>
          <Grid item xs={12} md={9}>
            <TextField
              required
              className="w-full"
              label="Url"
              name="externalLink"
              value={bannerData.externalLink}
              onChange={(e) => {
                const {value} = e.target;
                setBannerData((d) => ({...d, externalLink: value }));
              }}
            />
          </Grid>
        </Grid>}
        {bannerData.urlType === 'cmsIdentifier' &&
        <Grid container className="p-4 flex items-center">
          <Grid item xs={12} md={3}>Cms Identifier: <span className="text-error">*</span></Grid>
          <Grid item xs={12} md={9}>
            <TextField
              required
              className="w-full"
              label="Identifier"
              name="cmsIdentifier"
              value={bannerData.cmsIdentifier}
              onChange={(e) => {
                const {value} = e.target;
                setBannerData((d) => ({...d, cmsIdentifier: value }));
              }}
            />
          </Grid>
        </Grid>}
        <Grid container className="p-4 flex items-center justify-around">
          <Button
            color="primary"
            variant="contained"
            className="capitalize"
            onClick={handleSaveSlide}
          >
            Save Slide
          </Button>
          <Button
            variant="contained"
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default BannerSlideModal;
